import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLenis } from "lenis/react";
import { NAV_LINKS } from "./data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const year = new Date().getFullYear();
  const lenis = useLenis();
  const [info, setInfo] = useState({ email: "", phone: "", location: "" });

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const go = (href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const navItems = [{ label: "Home", href: "#top" }, ...NAV_LINKS];

  return (
    <footer data-testid="site-footer" className="bg-foreground text-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl font-medium">Peoplelab Advisory</h3>
            <p className="mt-4 text-background/60 max-w-sm leading-relaxed">
              People, process and possibilities — the HR partner behind teams that go the distance.
            </p>
            <button
              data-testid="footer-cta"
              onClick={() => go("#contact")}
              className="mt-6 inline-flex rounded-full bg-accent text-white px-6 py-3 text-sm font-medium hover:brightness-110 transition-[filter]"
            >
              Start a conversation
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="text-xs uppercase tracking-widest text-background/40 mb-4">Navigate</div>
            <ul className="space-y-3">
              {navItems.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    onClick={() => go(l.href)}
                    className="text-background/70 hover:text-secondary transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-background/40 mb-4">Reach us</div>
            <ul className="space-y-3 text-background/70 text-sm" data-testid="footer-reach-us">
              {info.email ? (
                <li>
                  <a href={`mailto:${info.email}`} className="hover:text-secondary transition-colors break-all" data-testid="footer-email">
                    {info.email}
                  </a>
                </li>
              ) : null}
              {info.phone ? (
                <li>
                  <a href={`tel:${info.phone.replace(/\s/g, "")}`} className="hover:text-secondary transition-colors" data-testid="footer-phone">
                    {info.phone}
                  </a>
                </li>
              ) : null}
              {info.location ? <li data-testid="footer-location">{info.location}</li> : null}
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-background/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background/40">© {year} Peoplelab Advisory. All rights reserved.</p>
          <p className="font-serif-display italic text-background/50">People | Process | Possibilities</p>
        </div>
      </div>

      <div className="select-none pointer-events-none">
        <div className="font-heading font-bold text-background/[0.04] leading-none text-center text-[22vw] -mt-[4vw] tracking-tighter">
          PEOPLELAB
        </div>
      </div>
    </footer>
  );
};
